<template>
  <div ref="component"
    class=" cubeSpace d-flex flex-wrap justify-content-center align-items-center align-content-start align-content-lg-center py-4 px-3 px-lg-0 my-3 my-lg-0">
    <div
      class="col-lg-6 col-12 d-flex flex-wrap justify-content-start align-items-center align-content-center ps-lg-5 px-2 mt-sm-5 mt-lg-0">
      <div class="col-12 d-flex justify-content-start text-start align-items-center flex-wrap">
        <span class="font- label-1 fuente-posm fuentes-clamp5">Diseñamos Servicios que</span> 
          <span class="font- label-1 fuente-posm fuentes-clamp5">Generan
            Experiencias</span>
      </div>

      <div class="col-12 d-flex justify-content-start text-start align-items-center flex-wrap my-5 ms-lg-5">
        <span class="w-100 ms-lg-1"><button class="slide- fuente-nova2 button-outline font- hover-boton_mod"
            @click="openContactModal">
            Descubre Como
          </button></span>
      </div>
    </div>
    <div
      class="col-lg-6 col-12 col-sm-10 d-flex flex-wrap justify-content-start align-items-lg-end align-items-center pe-lg-5 px-2 pt-0 pt-lg-5">
      <div class="col-12 d-flex justify-content-end text-start align-items-center flex-wrap mt-lg-5 pe-5">
        <span class="font- slide- fuente-nova label-2 mt-lg-1 d-flex flex-wrap fuentes-clamp6">
          <img :src="a8" class="w-100 imagen-dimension" alt="a8" />
          Estamos seguros que podemos encontrar cómo mejorar las experiencias de tus
          clientes y resaltar tu marca.
        </span>
      </div>
    </div>
  </div>
  <ContactModal />
</template>
<script>
import ContactModal from '@/components/modal/Contact.vue'
export default {
  components: { ContactModal },
  name: "page1",
  emits: ["sendAction"],
  props: {
    action: {
      type: Object,
      default: () => { },
    },
    pos: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      a8: require("@/assets/images/a8.webp"),
    };
  },
  watch: {
    action: {
      handler() {
        this.getAction();
      },
      deep: true,
    },
  },
  mounted() {
    this.getComponentHeight();
  },
  methods: {
    openContactModal() {
      const modalEl = document.getElementById('contactModal');
      if (modalEl) {
        import('bootstrap').then(({ Modal }) => {
          const contactModal = new Modal(modalEl);
          contactModal.show();
        });
      }
    },
    getComponentHeight() {
      let component = this.$refs.component;
      this.$emit("sendAction", {
        action: "setHeight",
        data: { pos: this.pos, val: component.offsetHeight },
      });
    },
    makeAction() {
      switch (this.action.type) {
        case "?":
          break;
      }
    },
  },
};
</script>
<style lang="css" scoped>
/* @font-face {
  font-family: 'Kefa';
  src: url(../../assets/fonts/Kefa.ttf);
 
} */

/* body{
  background-color: white !important;
} */

.cubeSpace {
  overflow: hidden;
  height: auto;
  width: 100vw;
  height: 100vh;
}

.bordes-arriba {
  border-top-left-radius: 150px;
  border-top-right-radius: 150px;
}

.label-1 {
  color: var(--color-2);
  font-size: 70px;
  line-height: 1.1;
  word-wrap: break-word;
}

.label-2 {
  color: var(--color-1);
  font-size: 24px;
  line-height: 1.1;
  max-width: 600px;
}

.label-3 {
  color: var(--color-3);
  font-size: 25px;
  line-height: 1.1;
}

.label-4 {
  color: var(--color-1);
  font-size: 24px;
  line-height: 1.1;
}

@media screen and (max-width: 1780px){
  .label-1 {
  color: var(--color-2);
  font-size: 50px !important;
  line-height: 1.1;
  word-wrap: break-word;
}

}
.label-1 {
  color: var(--color-2);
  font-size: 70px;
  line-height: 1.1;
  word-wrap: break-word;
}

.imagen-dimension {
  width: 80% !important;
  height: auto;
}


@media screen and (max-width: 1280px) {
  .button-outline {
    font-size: 18px;
    color: var(--color-2);
    text-align: center;
    outline: none;
    border-radius: 6px;
    padding: 5px 20px;
    background-color: transparent;
    border: 2px solid var(--color-2);
    cursor: pointer;
  }
  .label-1 {
  color: var(--color-2);
  font-size: 44px !important;
  line-height: 1.1;
  word-wrap: break-word;
}
  
}

@media (max-width: 992px) and (min-width: 768px) {
  .label-1 {
    font-size: 60px;
  }

  .label-2 {
    font-size: 22px;
  }

  .label-3 {
    font-size: 23px;
  }

  .label-4 {
    font-size: 22px;
  }
}

@media (max-width: 767px) and (min-width: 0) {
  .label-1 {
    font-size: 34px;
  }

  .label-2 {
    font-size: 14px;
  }

  .label-3 {
    font-size: 15px;
  }

  .label-4 {
    font-size: 14px;
  }
}
@media screen and (max-width: 490px) {
  
  .label-1 {
  color: var(--color-2);
  font-size: 25px !important;
  line-height: 1.1;
  word-wrap: break-word;
}

.imagen-dimension {
  width: 100% !important;
  height: auto;
}

  
}
</style>